import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@common/queryKeys";
import { fetchBoards } from "@api/boards";

export const usePrintFaqQuery = () => {
  return useQuery({
    queryKey: QUERY_KEYS.CUSTOMIZING.PRINT.FAQ,
    queryFn: async () => {
      const body = {
        modes: "List",
        boardName: "sfaq",
      };

      const res = await fetchBoards(body); // API 호출

      if (res.Code === "0000" || res.code === "0000") {
        return res.data.data; // 정상 데이터 반환
      } else {
        return [];
      }
    },
    retry: 1, // 요청 실패 시 한 번만 재시도
  });
};
